import { useTranslate } from "@similarweb/i18n-provider";
import { colorsPalettes } from "@similarweb/styles";
import { Button, Modal } from "@similarweb/ui-components";
import { Text } from "@similarweb/ui-components/foundations";

type Props = {
    isOpen: boolean;
    onCancel: () => void;
    onConfirm: () => void;
};

const UNSAVED_CHANGES_MODAL_STYLES = {
    overlay: {
        zIndex: 1080,
    },
    content: {
        width: "420px",
        padding: "0",
    },
};

export const UnsavedChangesModal = ({ isOpen, onCancel, onConfirm }: Props) => {
    const { translate } = useTranslate();

    return (
        <Modal
            isOpen={isOpen}
            onRequestClose={onCancel}
            customStyles={UNSAVED_CHANGES_MODAL_STYLES}
            data-automation="playbook-wizard-unsaved-changes-modal"
        >
            <Modal.Header>
                <Modal.Title data-automation="playbook-wizard-unsaved-changes-modal-title">
                    {translate("si.playbooks.wizard.unsaved_changes.title")}
                </Modal.Title>
            </Modal.Header>
            <Modal.Content>
                <Text
                    fontVariant="body2"
                    color={colorsPalettes.carbon["400"]}
                    data-automation="playbook-wizard-unsaved-changes-modal-body"
                >
                    {translate("si.playbooks.wizard.unsaved_changes.body")}
                </Text>
            </Modal.Content>
            <Modal.Footer>
                <Button
                    type="flat"
                    onClick={onCancel}
                    dataAutomation="playbook-wizard-unsaved-changes-modal-stay"
                >
                    {translate("si.playbooks.wizard.unsaved_changes.stay")}
                </Button>
                <Button
                    type="primary"
                    onClick={onConfirm}
                    dataAutomation="playbook-wizard-unsaved-changes-modal-leave"
                >
                    {translate("si.playbooks.wizard.unsaved_changes.leave")}
                </Button>
            </Modal.Footer>
        </Modal>
    );
};
